export type TimezoneOption = { id: string; label: string; offset: string };

export const TIMEZONE_OPTIONS = [
  {
    id: 'Pacific/Niue',
    label: '(GMT-11:00) Niue',
    offset: '-11:00',
  },
  {
    id: 'Pacific/Pago_Pago',
    label: '(GMT-11:00) Pago Pago',
    offset: '-11:00',
  },
  {
    id: 'Pacific/Honolulu',
    label: '(GMT-10:00) Hawaii Time',
    offset: '-10:00',
  },
  {
    id: 'Pacific/Rarotonga',
    label: '(GMT-10:00) Rarotonga',
    offset: '-10:00',
  },
  {
    id: 'Pacific/Tahiti',
    label: '(GMT-10:00) Tahiti',
    offset: '-10:00',
  },
  {
    id: 'Pacific/Marquesas',
    label: '(GMT-09:30) Marquesas',
    offset: '-09:30',
  },
  {
    id: 'America/Anchorage',
    label: '(GMT-09:00) Alaska Time',
    offset: '-09:00',
  },
  {
    id: 'Pacific/Gambier',
    label: '(GMT-09:00) Gambier',
    offset: '-09:00',
  },
  {
    id: 'America/Los_Angeles',
    label: '(GMT-08:00) Pacific Time',
    offset: '-08:00',
  },
  {
    id: 'America/Tijuana',
    label: '(GMT-08:00) Pacific Time - Tijuana',
    offset: '-08:00',
  },
  {
    id: 'America/Vancouver',
    label: '(GMT-08:00) Pacific Time - Vancouver',
    offset: '-08:00',
  },
  {
    id: 'America/Whitehorse',
    label: '(GMT-08:00) Pacific Time - Whitehorse',
    offset: '-08:00',
  },
  {
    id: 'Pacific/Pitcairn',
    label: '(GMT-08:00) Pitcairn',
    offset: '-08:00',
  },
  {
    id: 'America/Dawson_Creek',
    label: '(GMT-07:00) Mountain Time - Dawson Creek',
    offset: '-07:00',
  },
  {
    id: 'America/Denver',
    label: '(GMT-07:00) Mountain Time',
    offset: '-07:00',
  },
  {
    id: 'America/Edmonton',
    label: '(GMT-07:00) Mountain Time - Edmonton',
    offset: '-07:00',
  },
  {
    id: 'America/Hermosillo',
    label: '(GMT-07:00) Mountain Time - Hermosillo',
    offset: '-07:00',
  },
  {
    id: 'America/Mazatlan',
    label: '(GMT-07:00) Mountain Time - Chihuahua, Mazatlan',
    offset: '-07:00',
  },
  {
    id: 'America/Phoenix',
    label: '(GMT-07:00) Mountain Time - Arizona',
    offset: '-07:00',
  },
  {
    id: 'America/Yellowknife',
    label: '(GMT-07:00) Mountain Time - Yellowknife',
    offset: '-07:00',
  },
  {
    id: 'America/Belize',
    label: '(GMT-06:00) Belize',
    offset: '-06:00',
  },
  {
    id: 'America/Chicago',
    label: '(GMT-06:00) Central Time',
    offset: '-06:00',
  },
  {
    id: 'America/Costa_Rica',
    label: '(GMT-06:00) Costa Rica',
    offset: '-06:00',
  },
  {
    id: 'America/El_Salvador',
    label: '(GMT-06:00) El Salvador',
    offset: '-06:00',
  },
  {
    id: 'America/Guatemala',
    label: '(GMT-06:00) Guatemala',
    offset: '-06:00',
  },
  {
    id: 'America/Managua',
    label: '(GMT-06:00) Managua',
    offset: '-06:00',
  },
  {
    id: 'America/Mexico_City',
    label: '(GMT-06:00) Central Time - Mexico City',
    offset: '-06:00',
  },
  {
    id: 'America/Regina',
    label: '(GMT-06:00) Central Time - Regina',
    offset: '-06:00',
  },
  {
    id: 'America/Tegucigalpa',
    label: '(GMT-06:00) Central Time - Tegucigalpa',
    offset: '-06:00',
  },
  {
    id: 'America/Winnipeg',
    label: '(GMT-06:00) Central Time - Winnipeg',
    offset: '-06:00',
  },
  {
    id: 'Pacific/Galapagos',
    label: '(GMT-06:00) Galapagos',
    offset: '-06:00',
  },
  {
    id: 'America/Bogota',
    label: '(GMT-05:00) Bogota',
    offset: '-05:00',
  },
  {
    id: 'America/Cancun',
    label: '(GMT-05:00) America Cancun',
    offset: '-05:00',
  },
  {
    id: 'America/Cayman',
    label: '(GMT-05:00) Cayman',
    offset: '-05:00',
  },
  {
    id: 'America/Guayaquil',
    label: '(GMT-05:00) Guayaquil',
    offset: '-05:00',
  },
  {
    id: 'America/Havana',
    label: '(GMT-05:00) Havana',
    offset: '-05:00',
  },
  {
    id: 'America/Iqaluit',
    label: '(GMT-05:00) Eastern Time - Iqaluit',
    offset: '-05:00',
  },
  {
    id: 'America/Jamaica',
    label: '(GMT-05:00) Jamaica',
    offset: '-05:00',
  },
  {
    id: 'America/Lima',
    label: '(GMT-05:00) Lima',
    offset: '-05:00',
  },
  {
    id: 'America/Nassau',
    label: '(GMT-05:00) Nassau',
    offset: '-05:00',
  },
  {
    id: 'America/New_York',
    label: '(GMT-05:00) Eastern Time',
    offset: '-05:00',
  },
  {
    id: 'America/Panama',
    label: '(GMT-05:00) Panama',
    offset: '-05:00',
  },
  {
    id: 'America/Port-au-Prince',
    label: '(GMT-05:00) Port-au-Prince',
    offset: '-05:00',
  },
  {
    id: 'America/Rio_Branco',
    label: '(GMT-05:00) Rio Branco',
    offset: '-05:00',
  },
  {
    id: 'America/Toronto',
    label: '(GMT-05:00) Eastern Time - Toronto',
    offset: '-05:00',
  },
  {
    id: 'Pacific/Easter',
    label: '(GMT-05:00) Easter Island',
    offset: '-05:00',
  },
  {
    id: 'America/Caracas',
    label: '(GMT-04:00) Caracas',
    offset: '-04:00',
  },
  {
    id: 'America/Asuncion',
    label: '(GMT-03:00) Asuncion',
    offset: '-03:00',
  },
  {
    id: 'America/Barbados',
    label: '(GMT-04:00) Barbados',
    offset: '-04:00',
  },
  {
    id: 'America/Boa_Vista',
    label: '(GMT-04:00) Boa Vista',
    offset: '-04:00',
  },
  {
    id: 'America/Campo_Grande',
    label: '(GMT-03:00) Campo Grande',
    offset: '-03:00',
  },
  {
    id: 'America/Cuiaba',
    label: '(GMT-03:00) Cuiaba',
    offset: '-03:00',
  },
  {
    id: 'America/Curacao',
    label: '(GMT-04:00) Curacao',
    offset: '-04:00',
  },
  {
    id: 'America/Grand_Turk',
    label: '(GMT-04:00) Grand Turk',
    offset: '-04:00',
  },
  {
    id: 'America/Guyana',
    label: '(GMT-04:00) Guyana',
    offset: '-04:00',
  },
  {
    id: 'America/Halifax',
    label: '(GMT-04:00) Atlantic Time - Halifax',
    offset: '-04:00',
  },
  {
    id: 'America/La_Paz',
    label: '(GMT-04:00) La Paz',
    offset: '-04:00',
  },
  {
    id: 'America/Manaus',
    label: '(GMT-04:00) Manaus',
    offset: '-04:00',
  },
  {
    id: 'America/Martinique',
    label: '(GMT-04:00) Martinique',
    offset: '-04:00',
  },
  {
    id: 'America/Port_of_Spain',
    label: '(GMT-04:00) Port of Spain',
    offset: '-04:00',
  },
  {
    id: 'America/Porto_Velho',
    label: '(GMT-04:00) Porto Velho',
    offset: '-04:00',
  },
  {
    id: 'America/Puerto_Rico',
    label: '(GMT-04:00) Puerto Rico',
    offset: '-04:00',
  },
  {
    id: 'America/Santo_Domingo',
    label: '(GMT-04:00) Santo Domingo',
    offset: '-04:00',
  },
  {
    id: 'America/Thule',
    label: '(GMT-04:00) Thule',
    offset: '-04:00',
  },
  {
    id: 'Atlantic/Bermuda',
    label: '(GMT-04:00) Bermuda',
    offset: '-04:00',
  },
  {
    id: 'America/St_Johns',
    label: '(GMT-03:30) Newfoundland Time - St. Johns',
    offset: '-03:30',
  },
  {
    id: 'America/Araguaina',
    label: '(GMT-03:00) Araguaina',
    offset: '-03:00',
  },
  {
    id: 'America/Argentina/Buenos_Aires',
    label: '(GMT-03:00) Buenos Aires',
    offset: '-03:00',
  },
  {
    id: 'America/Bahia',
    label: '(GMT-03:00) Salvador',
    offset: '-03:00',
  },
  {
    id: 'America/Belem',
    label: '(GMT-03:00) Belem',
    offset: '-03:00',
  },
  {
    id: 'America/Cayenne',
    label: '(GMT-03:00) Cayenne',
    offset: '-03:00',
  },
  {
    id: 'America/Fortaleza',
    label: '(GMT-03:00) Fortaleza',
    offset: '-03:00',
  },
  {
    id: 'America/Godthab',
    label: '(GMT-03:00) Godthab',
    offset: '-03:00',
  },
  {
    id: 'America/Maceio',
    label: '(GMT-03:00) Maceio',
    offset: '-03:00',
  },
  {
    id: 'America/Miquelon',
    label: '(GMT-03:00) Miquelon',
    offset: '-03:00',
  },
  {
    id: 'America/Montevideo',
    label: '(GMT-03:00) Montevideo',
    offset: '-03:00',
  },
  {
    id: 'America/Paramaribo',
    label: '(GMT-03:00) Paramaribo',
    offset: '-03:00',
  },
  {
    id: 'America/Recife',
    label: '(GMT-03:00) Recife',
    offset: '-03:00',
  },
  {
    id: 'America/Santiago',
    label: '(GMT-03:00) Santiago',
    offset: '-03:00',
  },
  {
    id: 'America/Sao_Paulo',
    label: '(GMT-03:00) Sao Paulo',
    offset: '-03:00',
  },
  {
    id: 'Antarctica/Palmer',
    label: '(GMT-03:00) Palmer',
    offset: '-03:00',
  },
  {
    id: 'Antarctica/Rothera',
    label: '(GMT-03:00) Rothera',
    offset: '-03:00',
  },
  {
    id: 'Atlantic/Stanley',
    label: '(GMT-03:00) Stanley',
    offset: '-03:00',
  },
  {
    id: 'America/Noronha',
    label: '(GMT-02:00) Noronha',
    offset: '-02:00',
  },
  {
    id: 'Atlantic/South_Georgia',
    label: '(GMT-02:00) South Georgia',
    offset: '-02:00',
  },
  {
    id: 'America/Scoresbysund',
    label: '(GMT-01:00) Scoresbysund',
    offset: '-01:00',
  },
  {
    id: 'Atlantic/Azores',
    label: '(GMT-01:00) Azores',
    offset: '-01:00',
  },
  {
    id: 'Atlantic/Cape_Verde',
    label: '(GMT-01:00) Cape Verde',
    offset: '-01:00',
  },
  {
    id: 'Africa/Abidjan',
    label: '(GMT+00:00) Abidjan',
    offset: '+00:00',
  },
  {
    id: 'Africa/Accra',
    label: '(GMT+00:00) Accra',
    offset: '+00:00',
  },
  {
    id: 'Africa/Bissau',
    label: '(GMT+00:00) Bissau',
    offset: '+00:00',
  },
  {
    id: 'Africa/Casablanca',
    label: '(GMT+00:00) Casablanca',
    offset: '+00:00',
  },
  {
    id: 'Africa/El_Aaiun',
    label: '(GMT+00:00) El Aaiun',
    offset: '+00:00',
  },
  {
    id: 'Africa/Monrovia',
    label: '(GMT+00:00) Monrovia',
    offset: '+00:00',
  },
  {
    id: 'America/Danmarkshavn',
    label: '(GMT+00:00) Danmarkshavn',
    offset: '+00:00',
  },
  {
    id: 'Atlantic/Canary',
    label: '(GMT+00:00) Canary Islands',
    offset: '+00:00',
  },
  {
    id: 'Atlantic/Faroe',
    label: '(GMT+00:00) Faeroe',
    offset: '+00:00',
  },
  {
    id: 'Atlantic/Reykjavik',
    label: '(GMT+00:00) Reykjavik',
    offset: '+00:00',
  },
  {
    id: 'Etc/GMT',
    label: '(GMT+00:00) GMT (no daylight saving)',
    offset: '+00:00',
  },
  {
    id: 'Europe/Dublin',
    label: '(GMT+00:00) Dublin',
    offset: '+00:00',
  },
  {
    id: 'Europe/Lisbon',
    label: '(GMT+00:00) Lisbon',
    offset: '+00:00',
  },
  {
    id: 'Europe/London',
    label: '(GMT+00:00) London',
    offset: '+00:00',
  },
  {
    id: 'Africa/Algiers',
    label: '(GMT+01:00) Algiers',
    offset: '+01:00',
  },
  {
    id: 'Africa/Ceuta',
    label: '(GMT+01:00) Ceuta',
    offset: '+01:00',
  },
  {
    id: 'Africa/Lagos',
    label: '(GMT+01:00) Lagos',
    offset: '+01:00',
  },
  {
    id: 'Africa/Ndjamena',
    label: '(GMT+01:00) Ndjamena',
    offset: '+01:00',
  },
  {
    id: 'Africa/Tunis',
    label: '(GMT+01:00) Tunis',
    offset: '+01:00',
  },
  {
    id: 'Africa/Windhoek',
    label: '(GMT+02:00) Windhoek',
    offset: '+02:00',
  },
  {
    id: 'Europe/Amsterdam',
    label: '(GMT+01:00) Amsterdam',
    offset: '+01:00',
  },
  {
    id: 'Europe/Andorra',
    label: '(GMT+01:00) Andorra',
    offset: '+01:00',
  },
  {
    id: 'Europe/Belgrade',
    label: '(GMT+01:00) Central European Time - Belgrade',
    offset: '+01:00',
  },
  {
    id: 'Europe/Berlin',
    label: '(GMT+01:00) Berlin',
    offset: '+01:00',
  },
  {
    id: 'Europe/Brussels',
    label: '(GMT+01:00) Brussels',
    offset: '+01:00',
  },
  {
    id: 'Europe/Budapest',
    label: '(GMT+01:00) Budapest',
    offset: '+01:00',
  },
  {
    id: 'Europe/Copenhagen',
    label: '(GMT+01:00) Copenhagen',
    offset: '+01:00',
  },
  {
    id: 'Europe/Gibraltar',
    label: '(GMT+01:00) Gibraltar',
    offset: '+01:00',
  },
  {
    id: 'Europe/Luxembourg',
    label: '(GMT+01:00) Luxembourg',
    offset: '+01:00',
  },
  {
    id: 'Europe/Madrid',
    label: '(GMT+01:00) Madrid',
    offset: '+01:00',
  },
  {
    id: 'Europe/Malta',
    label: '(GMT+01:00) Malta',
    offset: '+01:00',
  },
  {
    id: 'Europe/Monaco',
    label: '(GMT+01:00) Monaco',
    offset: '+01:00',
  },
  {
    id: 'Europe/Oslo',
    label: '(GMT+01:00) Oslo',
    offset: '+01:00',
  },
  {
    id: 'Europe/Paris',
    label: '(GMT+01:00) Paris',
    offset: '+01:00',
  },
  {
    id: 'Europe/Prague',
    label: '(GMT+01:00) Central European Time - Prague',
    offset: '+01:00',
  },
  {
    id: 'Europe/Rome',
    label: '(GMT+01:00) Rome',
    offset: '+01:00',
  },
  {
    id: 'Europe/Stockholm',
    label: '(GMT+01:00) Stockholm',
    offset: '+01:00',
  },
  {
    id: 'Europe/Tirane',
    label: '(GMT+01:00) Tirane',
    offset: '+01:00',
  },
  {
    id: 'Europe/Vienna',
    label: '(GMT+01:00) Vienna',
    offset: '+01:00',
  },
  {
    id: 'Europe/Warsaw',
    label: '(GMT+01:00) Warsaw',
    offset: '+01:00',
  },
  {
    id: 'Europe/Zurich',
    label: '(GMT+01:00) Zurich',
    offset: '+01:00',
  },
  {
    id: 'Africa/Cairo',
    label: '(GMT+02:00) Cairo',
    offset: '+02:00',
  },
  {
    id: 'Africa/Johannesburg',
    label: '(GMT+02:00) Johannesburg',
    offset: '+02:00',
  },
  {
    id: 'Africa/Maputo',
    label: '(GMT+02:00) Maputo',
    offset: '+02:00',
  },
  {
    id: 'Africa/Tripoli',
    label: '(GMT+02:00) Tripoli',
    offset: '+02:00',
  },
  {
    id: 'Asia/Amman',
    label: '(GMT+02:00) Amman',
    offset: '+02:00',
  },
  {
    id: 'Asia/Beirut',
    label: '(GMT+02:00) Beirut',
    offset: '+02:00',
  },
  {
    id: 'Asia/Damascus',
    label: '(GMT+02:00) Damascus',
    offset: '+02:00',
  },
  {
    id: 'Asia/Gaza',
    label: '(GMT+02:00) Gaza',
    offset: '+02:00',
  },
  {
    id: 'Asia/Jerusalem',
    label: '(GMT+02:00) Jerusalem',
    offset: '+02:00',
  },
  {
    id: 'Asia/Nicosia',
    label: '(GMT+02:00) Nicosia',
    offset: '+02:00',
  },
  {
    id: 'Europe/Athens',
    label: '(GMT+02:00) Athens',
    offset: '+02:00',
  },
  {
    id: 'Europe/Bucharest',
    label: '(GMT+02:00) Bucharest',
    offset: '+02:00',
  },
  {
    id: 'Europe/Chisinau',
    label: '(GMT+02:00) Chisinau',
    offset: '+02:00',
  },
  {
    id: 'Europe/Helsinki',
    label: '(GMT+02:00) Helsinki',
    offset: '+02:00',
  },
  {
    id: 'Europe/Istanbul',
    label: '(GMT+03:00) Istanbul',
    offset: '+03:00',
  },
  {
    id: 'Europe/Kaliningrad',
    label: '(GMT+02:00) Moscow-01 - Kaliningrad',
    offset: '+02:00',
  },
  {
    id: 'Europe/Kyiv',
    label: '(GMT+02:00) Kyiv',
    offset: '+02:00',
  },
  {
    id: 'Europe/Riga',
    label: '(GMT+02:00) Riga',
    offset: '+02:00',
  },
  {
    id: 'Europe/Sofia',
    label: '(GMT+02:00) Sofia',
    offset: '+02:00',
  },
  {
    id: 'Europe/Tallinn',
    label: '(GMT+02:00) Tallinn',
    offset: '+02:00',
  },
  {
    id: 'Europe/Vilnius',
    label: '(GMT+02:00) Vilnius',
    offset: '+02:00',
  },
  {
    id: 'Africa/Khartoum',
    label: '(GMT+03:00) Khartoum',
    offset: '+03:00',
  },
  {
    id: 'Africa/Nairobi',
    label: '(GMT+03:00) Nairobi',
    offset: '+03:00',
  },
  {
    id: 'Antarctica/Syowa',
    label: '(GMT+03:00) Syowa',
    offset: '+03:00',
  },
  {
    id: 'Asia/Baghdad',
    label: '(GMT+03:00) Baghdad',
    offset: '+03:00',
  },
  {
    id: 'Asia/Qatar',
    label: '(GMT+03:00) Qatar',
    offset: '+03:00',
  },
  {
    id: 'Asia/Riyadh',
    label: '(GMT+03:00) Riyadh',
    offset: '+03:00',
  },
  {
    id: 'Europe/Minsk',
    label: '(GMT+03:00) Minsk',
    offset: '+03:00',
  },
  {
    id: 'Europe/Moscow',
    label: '(GMT+03:00) Moscow+00 - Moscow',
    offset: '+03:00',
  },
  {
    id: 'Asia/Tehran',
    label: '(GMT+03:30) Tehran',
    offset: '+03:30',
  },
  {
    id: 'Asia/Baku',
    label: '(GMT+04:00) Baku',
    offset: '+04:00',
  },
  {
    id: 'Asia/Dubai',
    label: '(GMT+04:00) Dubai',
    offset: '+04:00',
  },
  {
    id: 'Asia/Tbilisi',
    label: '(GMT+04:00) Tbilisi',
    offset: '+04:00',
  },
  {
    id: 'Asia/Yerevan',
    label: '(GMT+04:00) Yerevan',
    offset: '+04:00',
  },
  {
    id: 'Europe/Samara',
    label: '(GMT+04:00) Moscow+01 - Samara',
    offset: '+04:00',
  },
  {
    id: 'Indian/Mahe',
    label: '(GMT+04:00) Mahe',
    offset: '+04:00',
  },
  {
    id: 'Indian/Mauritius',
    label: '(GMT+04:00) Mauritius',
    offset: '+04:00',
  },
  {
    id: 'Indian/Reunion',
    label: '(GMT+04:00) Reunion',
    offset: '+04:00',
  },
  {
    id: 'Asia/Kabul',
    label: '(GMT+04:30) Kabul',
    offset: '+04:30',
  },
  {
    id: 'Antarctica/Mawson',
    label: '(GMT+05:00) Mawson',
    offset: '+05:00',
  },
  {
    id: 'Asia/Aqtau',
    label: '(GMT+05:00) Aqtau',
    offset: '+05:00',
  },
  {
    id: 'Asia/Aqtobe',
    label: '(GMT+05:00) Aqtobe',
    offset: '+05:00',
  },
  {
    id: 'Asia/Ashgabat',
    label: '(GMT+05:00) Ashgabat',
    offset: '+05:00',
  },
  {
    id: 'Asia/Dushanbe',
    label: '(GMT+05:00) Dushanbe',
    offset: '+05:00',
  },
  {
    id: 'Asia/Karachi',
    label: '(GMT+05:00) Karachi',
    offset: '+05:00',
  },
  {
    id: 'Asia/Tashkent',
    label: '(GMT+05:00) Tashkent',
    offset: '+05:00',
  },
  {
    id: 'Asia/Yekaterinburg',
    label: '(GMT+05:00) Moscow+02 - Yekaterinburg',
    offset: '+05:00',
  },
  {
    id: 'Indian/Kerguelen',
    label: '(GMT+05:00) Kerguelen',
    offset: '+05:00',
  },
  {
    id: 'Indian/Maldives',
    label: '(GMT+05:00) Maldives',
    offset: '+05:00',
  },
  {
    id: 'Asia/Calcutta',
    label: '(GMT+05:30) India Standard Time',
    offset: '+05:30',
  },
  {
    id: 'Asia/Colombo',
    label: '(GMT+05:30) Colombo',
    offset: '+05:30',
  },
  {
    id: 'Asia/Katmandu',
    label: '(GMT+05:45) Katmandu',
    offset: '+05:45',
  },
  {
    id: 'Antarctica/Vostok',
    label: '(GMT+06:00) Vostok',
    offset: '+06:00',
  },
  {
    id: 'Asia/Almaty',
    label: '(GMT+06:00) Almaty',
    offset: '+06:00',
  },
  {
    id: 'Asia/Bishkek',
    label: '(GMT+06:00) Bishkek',
    offset: '+06:00',
  },
  {
    id: 'Asia/Dhaka',
    label: '(GMT+06:00) Dhaka',
    offset: '+06:00',
  },
  {
    id: 'Asia/Omsk',
    label: '(GMT+06:00) Moscow+03 - Omsk, Novosibirsk',
    offset: '+06:00',
  },
  {
    id: 'Asia/Thimphu',
    label: '(GMT+06:00) Thimphu',
    offset: '+06:00',
  },
  {
    id: 'Indian/Chagos',
    label: '(GMT+06:00) Chagos',
    offset: '+06:00',
  },
  {
    id: 'Asia/Rangoon',
    label: '(GMT+06:30) Rangoon',
    offset: '+06:30',
  },
  {
    id: 'Indian/Cocos',
    label: '(GMT+06:30) Cocos',
    offset: '+06:30',
  },
  {
    id: 'Antarctica/Davis',
    label: '(GMT+07:00) Davis',
    offset: '+07:00',
  },
  {
    id: 'Asia/Bangkok',
    label: '(GMT+07:00) Bangkok',
    offset: '+07:00',
  },
  {
    id: 'Asia/Hovd',
    label: '(GMT+07:00) Hovd',
    offset: '+07:00',
  },
  {
    id: 'Asia/Jakarta',
    label: '(GMT+07:00) Jakarta',
    offset: '+07:00',
  },
  {
    id: 'Asia/Krasnoyarsk',
    label: '(GMT+07:00) Moscow+04 - Krasnoyarsk',
    offset: '+07:00',
  },
  {
    id: 'Asia/Saigon',
    label: '(GMT+07:00) Hanoi',
    offset: '+07:00',
  },
  {
    id: 'Asia/Ho_Chi_Minh',
    label: '(GMT+07:00) Ho Chi Minh',
    offset: '+07:00',
  },
  {
    id: 'Indian/Christmas',
    label: '(GMT+07:00) Christmas',
    offset: '+07:00',
  },
  {
    id: 'Antarctica/Casey',
    label: '(GMT+08:00) Casey',
    offset: '+08:00',
  },
  {
    id: 'Asia/Brunei',
    label: '(GMT+08:00) Brunei',
    offset: '+08:00',
  },
  {
    id: 'Asia/Choibalsan',
    label: '(GMT+08:00) Choibalsan',
    offset: '+08:00',
  },
  {
    id: 'Asia/Hong_Kong',
    label: '(GMT+08:00) Hong Kong',
    offset: '+08:00',
  },
  {
    id: 'Asia/Irkutsk',
    label: '(GMT+08:00) Moscow+05 - Irkutsk',
    offset: '+08:00',
  },
  {
    id: 'Asia/Kuala_Lumpur',
    label: '(GMT+08:00) Kuala Lumpur',
    offset: '+08:00',
  },
  {
    id: 'Asia/Macau',
    label: '(GMT+08:00) Macau',
    offset: '+08:00',
  },
  {
    id: 'Asia/Makassar',
    label: '(GMT+08:00) Makassar',
    offset: '+08:00',
  },
  {
    id: 'Asia/Manila',
    label: '(GMT+08:00) Manila',
    offset: '+08:00',
  },
  {
    id: 'Asia/Shanghai',
    label: '(GMT+08:00) China Time - Beijing',
    offset: '+08:00',
  },
  {
    id: 'Asia/Singapore',
    label: '(GMT+08:00) Singapore',
    offset: '+08:00',
  },
  {
    id: 'Asia/Taipei',
    label: '(GMT+08:00) Taipei',
    offset: '+08:00',
  },
  {
    id: 'Asia/Ulaanbaatar',
    label: '(GMT+08:00) Ulaanbaatar',
    offset: '+08:00',
  },
  {
    id: 'Australia/Perth',
    label: '(GMT+08:00) Western Time - Perth',
    offset: '+08:00',
  },
  {
    id: 'Asia/Pyongyang',
    label: '(GMT+08:30) Pyongyang',
    offset: '+08:30',
  },
  {
    id: 'Asia/Dili',
    label: '(GMT+09:00) Dili',
    offset: '+09:00',
  },
  {
    id: 'Asia/Jayapura',
    label: '(GMT+09:00) Jayapura',
    offset: '+09:00',
  },
  {
    id: 'Asia/Seoul',
    label: '(GMT+09:00) Seoul',
    offset: '+09:00',
  },
  {
    id: 'Asia/Tokyo',
    label: '(GMT+09:00) Tokyo',
    offset: '+09:00',
  },
  {
    id: 'Asia/Yakutsk',
    label: '(GMT+09:00) Moscow+06 - Yakutsk',
    offset: '+09:00',
  },
  {
    id: 'Pacific/Palau',
    label: '(GMT+09:00) Palau',
    offset: '+09:00',
  },
  {
    id: 'Australia/Adelaide',
    label: '(GMT+10:30) Central Time - Adelaide',
    offset: '+10:30',
  },
  {
    id: 'Australia/Darwin',
    label: '(GMT+09:30) Central Time - Darwin',
    offset: '+09:30',
  },
  {
    id: 'Antarctica/DumontDUrville',
    label: "(GMT+10:00) Dumont D'Urville",
    offset: '+10:00',
  },
  {
    id: 'Asia/Magadan',
    label: '(GMT+10:00) Moscow+07 - Magadan',
    offset: '+10:00',
  },
  {
    id: 'Asia/Vladivostok',
    label: '(GMT+10:00) Moscow+07 - Vladivostok',
    offset: '+10:00',
  },
  {
    id: 'Australia/Brisbane',
    label: '(GMT+10:00) Eastern Time - Brisbane',
    offset: '+10:00',
  },
  {
    id: 'Asia/Yuzhno-Sakhalinsk',
    label: '(GMT+11:00) Moscow+08 - Yuzhno-Sakhalinsk',
    offset: '+11:00',
  },
  {
    id: 'Australia/Hobart',
    label: '(GMT+11:00) Eastern Time - Hobart',
    offset: '+11:00',
  },
  {
    id: 'Australia/Sydney',
    label: '(GMT+11:00) Eastern Time - Melbourne, Sydney',
    offset: '+11:00',
  },
  {
    id: 'Pacific/Chuuk',
    label: '(GMT+10:00) Truk',
    offset: '+10:00',
  },
  {
    id: 'Pacific/Guam',
    label: '(GMT+10:00) Guam',
    offset: '+10:00',
  },
  {
    id: 'Pacific/Port_Moresby',
    label: '(GMT+10:00) Port Moresby',
    offset: '+10:00',
  },
  {
    id: 'Pacific/Efate',
    label: '(GMT+11:00) Efate',
    offset: '+11:00',
  },
  {
    id: 'Pacific/Guadalcanal',
    label: '(GMT+11:00) Guadalcanal',
    offset: '+11:00',
  },
  {
    id: 'Pacific/Kosrae',
    label: '(GMT+11:00) Kosrae',
    offset: '+11:00',
  },
  {
    id: 'Pacific/Norfolk',
    label: '(GMT+11:00) Norfolk',
    offset: '+11:00',
  },
  {
    id: 'Pacific/Noumea',
    label: '(GMT+11:00) Noumea',
    offset: '+11:00',
  },
  {
    id: 'Pacific/Pohnpei',
    label: '(GMT+11:00) Ponape',
    offset: '+11:00',
  },
  {
    id: 'Asia/Kamchatka',
    label: '(GMT+12:00) Moscow+09 - Petropavlovsk-Kamchatskiy',
    offset: '+12:00',
  },
  {
    id: 'Pacific/Auckland',
    label: '(GMT+13:00) Auckland',
    offset: '+13:00',
  },
  {
    id: 'Pacific/Fiji',
    label: '(GMT+13:00) Fiji',
    offset: '+13:00',
  },
  {
    id: 'Pacific/Funafuti',
    label: '(GMT+12:00) Funafuti',
    offset: '+12:00',
  },
  {
    id: 'Pacific/Kwajalein',
    label: '(GMT+12:00) Kwajalein',
    offset: '+12:00',
  },
  {
    id: 'Pacific/Majuro',
    label: '(GMT+12:00) Majuro',
    offset: '+12:00',
  },
  {
    id: 'Pacific/Nauru',
    label: '(GMT+12:00) Nauru',
    offset: '+12:00',
  },
  {
    id: 'Pacific/Tarawa',
    label: '(GMT+12:00) Tarawa',
    offset: '+12:00',
  },
  {
    id: 'Pacific/Wake',
    label: '(GMT+12:00) Wake',
    offset: '+12:00',
  },
  {
    id: 'Pacific/Wallis',
    label: '(GMT+12:00) Wallis',
    offset: '+12:00',
  },
  {
    id: 'Pacific/Apia',
    label: '(GMT+14:00) Apia',
    offset: '+14:00',
  },
  {
    id: 'Pacific/Enderbury',
    label: '(GMT+13:00) Enderbury',
    offset: '+13:00',
  },
  {
    id: 'Pacific/Fakaofo',
    label: '(GMT+13:00) Fakaofo',
    offset: '+13:00',
  },
  {
    id: 'Pacific/Tongatapu',
    label: '(GMT+13:00) Tongatapu',
    offset: '+13:00',
  },
  {
    id: 'Pacific/Kiritimati',
    label: '(GMT+14:00) Kiritimati',
    offset: '+14:00',
  },
] as const;
